export const ADD_SUCCESS = 'Новая инструкция коннектора добавлена';
export const ADD_ERROR = 'Не удалось добавить инструкцию коннектора';
